import { create } from 'zustand';
import api from '../utils/api';

const useTenantStore = create((set) => ({
  tenantSettings: null,
  loading: false,
  error: null,

  fetchTenantSettings: async (slug) => {
    if (!slug) return;

    // No intentar obtener settings cuando estamos en local o en el dashboard principal
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const isLocalHost = host === 'localhost' || host === '127.0.0.1';
    const isMainDashboard = host === 'dashboard.legalcheck.com.co';
    if (isLocalHost || isMainDashboard) {
      // No hacemos la petición; dejamos tenantSettings como está (o null)
      return null;
    }

    set({ loading: true, error: null });
    try {
      const response = await api.get('/v1/tenant/settings/');
      const settings = response.data.data;
      
      // Aplicar colores dinámicos al root
      const root = document.documentElement;
      if (settings.settings?.primary_color) {
        root.style.setProperty('--color-primary', settings.settings.primary_color);
      }
      if (settings.settings?.secondary_color) {
        root.style.setProperty('--color-secondary', settings.settings.secondary_color);
      }

      set({ tenantSettings: settings, loading: false });
      return settings;
    } catch (error) {
      set({ error: 'Error al cargar configuración del portal', loading: false });
      console.error('Tenant settings error:', error);
    }
  },

  clearSettings: () => set({ tenantSettings: null })
}));

export default useTenantStore;
